import type { PropsWithChildren } from 'react';

import { Box, type BoxProps } from '@frontend/components';

import { useSelectStyles } from '../SelectStylesContext';

export interface GroupHeadingProps extends PropsWithChildren<unknown> {
  innerProps?: BoxProps;
}

export const GroupHeading = ({ innerProps, children }: GroupHeadingProps) => {
  const { groupHeading: groupHeadingStyles } = useSelectStyles();

  return (
    <Box {...innerProps} __css={groupHeadingStyles}>
      {children}
    </Box>
  );
};
